import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class ProductGroupKind extends Cloneable {
    static NONE = new ProductGroupKind("none", "NONE");
    static ANY = new ProductGroupKind("any", "ANY");

    static CHESTS = new ProductGroupKind("chests", "CHESTS");
    static CRYSTALS = new ProductGroupKind("crystals", "CRYSTALS");

    static CURRENCY = new ProductGroupKind("currency", "CURRENCY");
    static INGREDIENT = new ProductGroupKind("ingredient", "INGREDIENT");
    static DAILY_SALE = new ProductGroupKind("daily-sale", "DAILY_SALE");
    static FACTORIES = new ProductGroupKind("factories", "FACTORIES");

    //static ENERGY = new ProductGroupKind("energy", "ENERGY"); // old
    //static COINS = new ProductGroupKind("coins", "COINS");  // old

    static SEEDS = new ProductGroupKind("seeds", "SEEDS");
    static SPECIAL = new ProductGroupKind("special", "SPECIAL");
    static SURVEY = new ProductGroupKind("survey", "SURVEY");
    static ADDONS = new ProductGroupKind("addons", "ADDONS");
    static AVATARS = new ProductGroupKind("avatars", "AVATARS");
    static MARKET = new ProductGroupKind("market", "MARKET");
    static LONG_OFFER = new ProductGroupKind("long-offer", "LONG OFFER");
    static SMART_OFFERS = new ProductGroupKind("smart-offers", "SMART OFFERS");
    static BOOSTERS = new ProductGroupKind("boosters", "BOOSTERS");
    static DEVELOPMENT = new ProductGroupKind("development", "DEVELOPMENT");
    static CARDS = new ProductGroupKind("cards", "CARDS");

    static _values = [
        this.ANY,

        this.CHESTS,
        this.CRYSTALS,
        this.CURRENCY,
        this.INGREDIENT,
        this.DAILY_SALE,
        this.FACTORIES,

        //this.ENERGY,
        //this.COINS,

        this.SEEDS,
        this.SPECIAL,
        this.SURVEY,
        this.ADDONS,
        this.AVATARS,
        this.MARKET,
        this.LONG_OFFER,
        this.SMART_OFFERS,
        this.BOOSTERS,
        this.DEVELOPMENT,
        this.CARDS
    ];

    static getValues() {
        return ProductGroupKind._values;
    }

    static getValue(id) {
        let value = ProductGroupKind._values.find(v => v.id === id) || null;
        console.assert(value, "unknown kind: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, ProductGroupKind.getValue(id));
        });
    }

    static is(value) {
        if (value instanceof ProductGroupKind) {
            return ProductGroupKind._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    static isNone(value) {
        return ProductGroupKind.NONE.equal(value);
    }

    constructor(id = "none", name = "None") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    equal(value) {
        if (value instanceof ProductGroupKind) {
            return this.id === value.id;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ProductGroupKind());
        } else if (target instanceof ProductGroupKind) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ProductGroupKind, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});